import React, { Component } from 'react';
import DataCacheService from '@/shared/services/DataCacheService';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  SelectAValue: 'Select a value',
});

class CompanySelector extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    value: PropTypes.string,
  };
  static defaultProps = {
    value: null,
    required: false,
    placeholder: null,
  };

  state = {
    companies: [],
    selectedCompany: '',
  };

  componentDidMount() {
    const { value } = this.props;
    const companies = DataCacheService.getCompanies()
      .map(x => ({ ...x, label: x.name }))
      .sort(dynamicSort('label'));

    this.setState({
      companies,
      selectedCompany: value ? companies.find(x => x.id === value)?.id || '' : '',
    });
  }

  externalUpdate = value => {
    const { onChange } = this.props;
    this.setState(({ companies }) => {
      const companyId = value;
      const company = companyId ? companies.find(x => x.id === companyId) : null;
      if (!company && companyId) {
        onChange(null);
      }
      return {
        selectedCompany: company ? company.id : '',
      };
    });
  };

  componentDidUpdate(oldProps) {
    const { value, onChange } = this.props;
    const valueChanged = JSON.stringify(oldProps.value) !== JSON.stringify(value);
    if (!valueChanged) return;
    // eslint-disable-next-line react/no-did-update-set-state
    this.setState(({ companies }) => {
      const company = value ? companies.find(x => x.id === value) : null;
      if (!company && value) {
        onChange(null);
      }
      return {
        selectedCompany: value || '',
      };
    });
  }

  selectedValueChanged(e) {
    const { onChange } = this.props;
    const selectedCompany = e.target.value || '';
    this.setState({ selectedCompany }, () => onChange(selectedCompany || null));
  }

  render() {
    const { intl, placeholder, required } = this.props;
    const { companies, selectedCompany } = this.state;
    return (
      <select
        value={selectedCompany}
        className="form-control"
        onChange={e => this.selectedValueChanged(e)}
      >
        {(!required || !selectedCompany) && (
          <option value="">{placeholder ?? intl.formatMessage(messages.SelectAValue)}</option>
        )}
        {companies &&
          companies.map(company => (
            <option key={company.id} value={company.id}>
              {company.name}
            </option>
          ))}
      </select>
    );
  }
}

export default injectIntl(CompanySelector);
